/**
 * Script de Geolocalización para Tiendas Shopify
 * Detecta el país del usuario y muestra popups de redirección
 * 
 * Tienda Perú: lentesperu.com
 * Tienda México: lentesmexico.com
 */

(function() {
  'use strict';

  // Configuración de las tiendas
  const STORE_CONFIG = {
    peru: {
      domain: 'lentesdecontactoperu.com',
      country: 'PE',
      name: 'Perú',
      url: 'https://lentesdecontactoperu.com'
    },
    mexico: {
      domain: 'lentesdecontactomexico.mx',
      country: 'MX',
      name: 'México',
      url: 'https://lentesdecontactomexico.mx'
    }
  };

  // Cookie helper functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Detectar en qué tienda estamos
  function getCurrentStore() {
    const hostname = window.location.hostname;
    if (hostname.includes(STORE_CONFIG.peru.domain)) {
      return 'peru';
    } else if (hostname.includes(STORE_CONFIG.mexico.domain)) {
      return 'mexico';
    }
    return null;
  }

  // Obtener país del usuario usando API de geolocalización
  async function getUserCountry() {
    try {
      // Usar ipapi.co (gratuito, sin necesidad de API key)
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      return data.country_code; // Retorna código ISO (PE, MX, IT, etc.)
    } catch (error) {
      console.error('Error al obtener geolocalización:', error);
      return null;
    }
  }

  // Crear estilos del popup
  function createStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .geo-popup {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        padding: 20px 24px;
        max-width: 360px;
        z-index: 10000;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        animation: slideIn 0.3s ease-out;
      }

      @keyframes slideIn {
        from {
          transform: translateY(100px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      .geo-popup-content {
        margin-bottom: 16px;
      }

      .geo-popup-text {
        color: #333;
        font-size: 15px;
        line-height: 1.5;
        margin: 0;
      }

      .geo-popup-buttons {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
      }

      .geo-popup-btn {
        flex: 1;
        min-width: 100px;
        padding: 10px 16px;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      .geo-popup-btn-primary {
        background-image: linear-gradient(274deg, rgba(92, 101, 160, 1) 19%, rgba(103, 147, 200, 1) 46%, rgba(109, 190, 209, 1) 74%, rgba(124, 182, 192, 1) 100%);
        color: white;
      }

      .geo-popup-btn-primary:hover {
        background-image: linear-gradient(274deg, rgba(92, 101, 160, 1) 19%, rgba(103, 147, 200, 1) 46%, rgba(109, 190, 209, 1) 74%, rgba(124, 182, 192, 1) 100%);
        transform: translateY(-1px);
      }

      .geo-popup-btn-secondary {
        background-color: #f3f4f6;
        color: #374151;
      }

      .geo-popup-btn-secondary:hover {
        background-color: #e5e7eb;
        transform: translateY(-1px);
      }

      .geo-popup-close {
        position: absolute;
        top: 12px;
        right: 12px;
        background: none;
        border: none;
        color: #9ca3af;
        cursor: pointer;
        font-size: 20px;
        line-height: 1;
        padding: 4px;
        transition: color 0.2s;
      }

      .geo-popup-close:hover {
        color: #4b5563;
      }

      @media (max-width: 480px) {
        .geo-popup {
          bottom: 10px;
          right: 10px;
          left: 10px;
          max-width: none;
        }

        .geo-popup-buttons {
          flex-direction: column;
        }

        .geo-popup-btn {
          width: 100%;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Crear popup
  function createPopup(config) {
    const popup = document.createElement('div');
    popup.className = 'geo-popup';
    popup.innerHTML = `
      <button class="geo-popup-close" aria-label="Cerrar">×</button>
      <div class="geo-popup-content">
        <p class="geo-popup-text">${config.message}</p>
      </div>
      <div class="geo-popup-buttons">
        ${config.buttons}
      </div>
    `;
    
    document.body.appendChild(popup);
    return popup;
  }

  // Cerrar popup
  function closePopup(popup) {
    popup.style.animation = 'slideIn 0.3s ease-out reverse';
    setTimeout(() => {
      popup.remove();
    }, 300);
  }

  // Mostrar popup para visitantes fuera de Perú/México
  function showRestOfWorldPopup(currentStore) {
    const storeName = STORE_CONFIG[currentStore].name;
    
    const config = {
      message: `Parece que estás fuera de ${storeName}. ¿Deseas actualizar tu ubicación?`,
      buttons: `<button class="geo-popup-btn geo-popup-btn-primary" data-action="accept">Aceptar</button>`
    };

    const popup = createPopup(config);

    // Event listeners
    popup.querySelector('[data-action="accept"]').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });

    popup.querySelector('.geo-popup-close').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });
  }

  // Mostrar popup cuando el usuario está en Perú pero visita México
  function showPeruInMexicoPopup() {
    const config = {
      message: 'Parece que estás en Perú. ¿Deseas actualizar tu ubicación?',
      buttons: `
        <button class="geo-popup-btn geo-popup-btn-primary" data-action="peru">Perú</button>
        <button class="geo-popup-btn geo-popup-btn-secondary" data-action="stay">México</button>
      `
    };

    const popup = createPopup(config);

    // Event listeners
    popup.querySelector('[data-action="peru"]').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      window.location.href = STORE_CONFIG.peru.url;
    });

    popup.querySelector('[data-action="stay"]').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });

    popup.querySelector('.geo-popup-close').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });
  }

  // Mostrar popup cuando el usuario está en México pero visita Perú
  function showMexicoInPeruPopup() {
    const config = {
      message: 'Parece que estás en México. ¿Deseas actualizar tu ubicación?',
      buttons: `
        <button class="geo-popup-btn geo-popup-btn-primary" data-action="mexico">México</button>
        <button class="geo-popup-btn geo-popup-btn-secondary" data-action="stay">Perú</button>
      `
    };

    const popup = createPopup(config);

    // Event listeners
    popup.querySelector('[data-action="mexico"]').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      window.location.href = STORE_CONFIG.mexico.url;
    });

    popup.querySelector('[data-action="stay"]').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });

    popup.querySelector('.geo-popup-close').addEventListener('click', () => {
      setCookie('geo_popup_dismissed', 'true', 30);
      closePopup(popup);
    });
  }

  // Lógica principal
  async function init() {
    // Verificar si ya se mostró el popup
    if (getCookie('geo_popup_dismissed')) {
      return;
    }

    // Detectar tienda actual
    const currentStore = getCurrentStore();
    if (!currentStore) {
      console.warn('No se pudo detectar la tienda actual');
      return;
    }

    // Obtener país del usuario
    const userCountry = await getUserCountry();
    if (!userCountry) {
      console.warn('No se pudo obtener el país del usuario');
      return;
    }

    // Crear estilos
    createStyles();

    // Aplicar lógica según el país y la tienda
    if (userCountry === 'PE') {
      // Usuario en Perú
      if (currentStore === 'mexico') {
        // En Perú visitando México -> mostrar popup con opción de ir a Perú
        showPeruInMexicoPopup();
      }
      // Si está en Perú visitando Perú -> no hacer nada
    } else if (userCountry === 'MX') {
      // Usuario en México
      if (currentStore === 'peru') {
        // En México visitando Perú -> mostrar popup con opción de ir a México
        showMexicoInPeruPopup();
      }
      // Si está en México visitando México -> no hacer nada
    } else {
      // Usuario en resto del mundo -> mostrar popup simple
      showRestOfWorldPopup(currentStore);
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();